<template>
  <transition
    enter-active-class="animated slideInRight"
    leave-active-class="animated zoomOut"
  >
    <v-flex
      xs4
      v-if="
        Object.keys(activePlaylist).length !== 0 &&
        activePlaylist.constructor == Object
      "
    >
      <v-card>
        <v-toolbar
          dark
          color="secondary"
        >
          <v-toolbar-title>{{$t('library.playlistEditor')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            @click.prevent="savePlaylist()"
            icon
          >
            <v-icon>save</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-btn
                color="accent"
                @click="createPlaylistEvent()"
                dark
                block
              >
                <v-icon left dark>add</v-icon>
                {{$tc('library.event', 1)}}
              </v-btn>
            </v-flex>
            <v-flex xs12>
              <v-expansion-panel>
                <v-expansion-panel-content
                  v-for="(event, index) in activePlaylist.events"
                  :key="index"
                >
                  <div slot="header">
                    <b>Event {{index + 1}}</b>
                    <v-btn
                      @click.stop="deleteEvent(index)"
                      icon
                      ripple
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </div>
                  <playlist-event-options
                    :index="index"
                    :length="Object.keys(activePlaylist.events).length"
                  ></playlist-event-options>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </transition>
</template>

<script>
import axios from 'axios';
import PlaylistEventOptions from './PlaylistEventOptions.vue';

export default {
  components: {
    PlaylistEventOptions,
  },
  computed: {
    activePlaylist: {
      get() {
        return this.$store.getters.getActivePlaylist;
      },
    },
  },
  data() {
    return {
      apiUrl: window.api_url,
    };
  },
  mounted() {
    this.getLayouts();
  },
  methods: {
    createPlaylistEvent() {
      let payload = {};

      payload = {
        id: null,
        playlist_id: this.activePlaylist.id,
        event_order: this.activePlaylist.events.length,
        layout_id: null,
      };

      this.$store.dispatch('CREATE_PLAYLIST_EVENT', payload);
    },
    deleteEvent(index) {
      this.$store.dispatch('DELETE_PLAYLIST_EVENT', index);
      this.$toasted.show('Event successfully deleted', { duration: 3000, singleton: true, type: 'success' });
    },
    getLayouts() {
      const vm = this;

      axios.get(`${this.apiUrl}api/layouts`, {
        params: {
          paginate: false,
        },
      })
        .then((response) => {
          this.$store.dispatch('SET_LAYOUTS', response.data.data);
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
    savePlaylist() {
      const vm = this;

      axios.post(`${this.apiUrl}api/playlist/${this.activePlaylist.id}/events`, {
        events: this.activePlaylist.events,
      })
        .then((response) => {
          vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
  },
};
</script>

<style scoped>
.v-expansion-panel {
  box-shadow: none;
}
</style>
